"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _layouts = require("@seedlang/layouts");
var _lodash = require("lodash");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// remember: don't include AppUI in a UI file
var CreatorUI = (_class = /*#__PURE__*/function (_RootState) {
  function CreatorUI() {
    var _this;
    _classCallCheck(this, CreatorUI);
    _this = _callSuper(this, CreatorUI);
    _initializerDefineProperty(_this, "uploading", _descriptor, _this);
    _initializerDefineProperty(_this, "selectedSentenceId", _descriptor2, _this);
    _initializerDefineProperty(_this, "wordIndexIds", _descriptor3, _this);
    _initializerDefineProperty(_this, "selectedWordIndex", _descriptor4, _this);
    _initializerDefineProperty(_this, "conceptId", _descriptor5, _this);
    _initializerDefineProperty(_this, "conceptCategoryId", _descriptor6, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor7, _this);
    _initializerDefineProperty(_this, "deviceDeniedAccess", _descriptor8, _this);
    _initializerDefineProperty(_this, "autoAdvanceWord", _descriptor9, _this);
    _initializerDefineProperty(_this, "overwriteVideo", _descriptor0, _this);
    _this.afterConceptGetShow = function (resp) {
      _this.conceptStore.setShowData(resp);
    };
    _this.loadDecks = function (conceptId) {
      _this.deckStore.getIndex({
        filters: {
          concept_id: conceptId
        }
      });
    };
    _this.reloadConcepts = function () {
      _this.conceptStore.reloadIndexFiltered();
    };
    _this.getCookieValue = function (name) {
      return _this.cookieStore.getCookieValue(name, _this.user);
    };
    _this.setCookieValue = function (name, value) {
      _this.cookieStore.setCookieValue(name, value, _this.user);
    };
    // CONCEPT CATEGORY
    _this.onDeleteConcept = function (id) {
      _this.conceptStore.destroy({
        ids: {
          conceptId: id
        }
      }, _this.afterDeleteConcept);
    };
    _this.afterCreateVideo = function () {
      // shouldn't do this each time :/
      if (_this.concept) {
        _stores.ConceptStore.evaluateHasAllVideoClips({
          ids: {
            conceptId: _this.concept.id
          }
        }, _lodash.noop);
      }
      _this.loadSentences();
    };
    _this.afterCreateVideoRequestSent = function (params) {
      if (params.completed) {
        _this.uploading.push(params.sentenceId);
      }
    };
    _initializerDefineProperty(_this, "afterDeleteConcept", _descriptor1, _this);
    _initializerDefineProperty(_this, "afterLoadSentences", _descriptor10, _this);
    _this.onToggleAutoAdvanceWord = function () {
      _this.autoAdvanceWord = !_this.autoAdvanceWord;
      _this.setCookieValue('auto_advance_word', _this.autoAdvanceWord);
    };
    _this.onToggleOverwriteVideo = function () {
      _this.overwriteVideo = !_this.overwriteVideo;
      _this.setCookieValue('overwrite_video', _this.overwriteVideo);
    };
    _initializerDefineProperty(_this, "loadSentences", _descriptor11, _this);
    _initializerDefineProperty(_this, "onSelectSentenceId", _descriptor12, _this);
    _initializerDefineProperty(_this, "onDeleteSentence", _descriptor13, _this);
    _initializerDefineProperty(_this, "onChangeMedia", _descriptor14, _this);
    _initializerDefineProperty(_this, "afterCreateSentence", _descriptor15, _this);
    _this.layout = new _layouts.AppLayout(_this);
    _this.questionConceptStore = _stores.QuestionConceptStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.targetStore = _stores.TargetStore;
    _this.videoClipStore = _stores.VideoClipStore;
    _this.conceptCategoryStore = _stores.ConceptCategoryStore;
    _this.conceptStore = _stores.ConceptStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.levelStore = _stores.LevelStore;
    _this.sentenceConceptStore = _stores.SentenceConceptStore;
    _this.conceptCategoryConceptStore = _stores.ConceptCategoryConceptStore;
    _this.deckRulebookStore = _stores.DeckRulebookStore;
    _this.routeStore = _stores.RouteStore;
    _this.wordStore = _stores.WordStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.deckStore = _stores.DeckStore;
    _this.cookieStore = _stores.CookieStore;
    (0, _mobx.autorun)(function () {
      if (_this.wordStore.indexData.map(function (item) {
        return item.id;
      }).join(',') !== _this.wordIndexIds) {
        _this.wordIndexIds = _this.wordStore.indexData.map(function (item) {
          return item.id;
        }).join(',');
        _this.selectedWordIndex = 0;
      }
    });
    return _this;
  }
  _inherits(CreatorUI, _RootState);
  return _createClass(CreatorUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "conceptCategory",
    get: function get() {
      return this.conceptCategoryStore.showData;
    }
  }, {
    key: "concept",
    get: function get() {
      return this.conceptStore.showData;
    }
  }, {
    key: "concepts",
    get: function get() {
      return this.conceptCategoryConceptStore.indexData;
    }
  }, {
    key: "sentences",
    get: function get() {
      return this.sentenceConceptStore.indexData;
    }
  }, {
    key: "deck",
    get:
    // SETUP

    function get() {
      return this.deckStore.hasIndexData ? this.deckStore.indexData[0] : null;
    }
  }, {
    key: "answers",
    get: function get() {
      return this.sentences ? this.sentences.map(function (item) {
        return item.answers[0];
      }) : [];
    }
  }, {
    key: "createVideoClipStore",
    value: function createVideoClipStore() {
      this.videoClipRecorderStore = new _stores.VideoRecorderStore({
        parent: this
      });
    }
  }, {
    key: "loadConcept",
    value: function loadConcept(conceptId) {
      if ((0, _utils.isBlank)(this.concept) || conceptId !== this.concept.id) {
        this.conceptStore.getShow({
          ids: {
            conceptId: conceptId
          }
        }, this.afterConceptGetShow);
        this.loadSentences();
        this.loadDecks(conceptId);
      }
    }
  }, {
    key: "wordToRecord",
    get: function get() {
      if (this.wordStore.hasIndexData) {
        return this.wordStore.indexData[this.selectedWordIndex];
      }
      return null;
    }
  }, {
    key: "incrementWordToRecord",
    value: function incrementWordToRecord() {
      if (this.autoAdvanceWord && this.selectedWordIndex <= this.wordStore.indexData.length - 2) {
        this.selectedWordIndex += 1;
      } else {
        this.selectedWordIndex = 0;
      }
    }
  }, {
    key: "deckRulebookSlug",
    get:
    //

    function get() {
      if ((0, _utils.isPresent)(this.conceptCategory)) {
        return this.conceptCategory.deckRulebook.slug === 'story' ? 'default' : this.conceptCategory.deckRulebook.slug;
      }
      return null;
    }
  }, {
    key: "showSentenceStudio",
    get: function get() {
      return this.sentenceId;
    }
  }, {
    key: "sentenceId",
    get: function get() {
      return this.selectedSentenceId || this.firstUnrecordedSentenceId;
    }
  }, {
    key: "firstUnrecordedSentenceId",
    get: function get() {
      var _this2 = this;
      var sentenceId;
      if ((0, _utils.isBlank)(this.sentences)) {
        return;
      }
      (0, _lodash.each)(this.sentences, function (sentence) {
        if (!sentenceId && !sentence.hasAllVideoClips && !_this2.uploading.includes(sentence.id)) {
          sentenceId = sentence.id;
        }
        if (!sentenceId && sentence.hasAnswers && !sentence.answers[0].hasAllVideoClips && !_this2.uploading.includes(sentence.answers[0].id)) {
          sentenceId = sentence.answers[0].id;
        }
      });
      return sentenceId;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.selectedSentenceId = null;
      this.selectedWordIndex = 0;
      this.videoClip = null;
      this.wordIndexIds = null;
      this.uploading = [];
      this.sentenceConceptStore.clearIndexData();
    }
  }, {
    key: "setOnChangeCreatorCallback",
    value: function setOnChangeCreatorCallback(callback) {
      this.onChangeCreatorCallback = callback;
    }
  }, {
    key: "onClickWordRecord",
    value: function onClickWordRecord(word) {
      this.selectedWordIndex = this.wordStore.indexData.map(function (item) {
        return item.id;
      }).indexOf(word.id);
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "uploading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conceptCategory", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conceptCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "concept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "concept"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "concepts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "concepts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentences"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSentenceId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "wordIndexIds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedWordIndex", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "conceptId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "conceptCategoryId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deviceDeniedAccess", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "autoAdvanceWord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getCookieValue('auto_advance_word');
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "overwriteVideo", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.getCookieValue('overwrite_video');
  }
}), _applyDecoratedDescriptor(_class.prototype, "deck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createVideoClipStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createVideoClipStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadConcept", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadConcept"), _class.prototype), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "afterDeleteConcept", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      _this3.conceptCategoryConceptStore.getIndex({
        sort: 'name',
        ids: {
          conceptCategoryId: _this3.conceptCategoryId
        }
      });
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "wordToRecord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordToRecord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementWordToRecord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementWordToRecord"), _class.prototype), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "afterLoadSentences", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (resp) {
      _this4.sentenceConceptStore.afterGetIndex(resp);
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "deckRulebookSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckRulebookSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSentenceStudio", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSentenceStudio"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sentenceId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentenceId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstUnrecordedSentenceId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstUnrecordedSentenceId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "loadSentences", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function () {
      _this5.sentenceConceptStore.getIndex({
        limit: 100,
        ids: {
          conceptId: _this5.conceptId
        }
      }, _this5.afterLoadSentences);
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "onSelectSentenceId", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (selectedSentenceId) {
      _this6.selectedSentenceId = selectedSentenceId === _this6.firstUnrecordedSentenceId ? null : selectedSentenceId;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "onDeleteSentence", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (id) {
      _this7.sentenceStore.destroy({
        ids: {
          sentenceId: id
        }
      }, _this7.loadSentences);
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "onChangeMedia", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      _this8.conceptStore.getShow({
        ids: {
          conceptId: _this8.conceptId
        }
      });
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "afterCreateSentence", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      _this9.loadSentences();
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "setOnChangeCreatorCallback", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setOnChangeCreatorCallback"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickWordRecord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickWordRecord"), _class.prototype), _class);
var _default = exports["default"] = new CreatorUI();